module.exports = __webpack_public_path__ + "186d1bb06afd9d0cb0744cb2d37ebdcf.svg";